import { z } from 'zod';

// Runtime metadata is the provider-facing image evidence contract. It is
// deliberately independent from the versioned client payload contract.
export const imageRuntimeMetaSchema = z
  .object({
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    format: z.string().trim().min(1).max(64),
    hasTransparentPixels: z.boolean(),
  })
  .strict();

export type ImageRuntimeMeta = z.infer<typeof imageRuntimeMetaSchema>;

export function projectImageRuntimeMeta(
  meta: Readonly<ImageRuntimeMeta>
): ImageRuntimeMeta {
  return {
    width: meta.width,
    height: meta.height,
    format: meta.format,
    hasTransparentPixels: meta.hasTransparentPixels,
  };
}
